import { Box, Grid, Typography } from '@mui/material'
import React from 'react'
import { useTheme } from '@mui/material';
import { tokens } from '../../theme';
import Laptopimage from './about.png'
import Type from '../Type/Type';
import { Intro } from './Intro';
import Tilt from "react-parallax-tilt";
import Myimage from './Abhi.jpg'

import { RiInstagramLine } from "react-icons/ri";
import { FaGithub } from "react-icons/fa";

import { FaLinkedinIn } from "react-icons/fa";
import Avatar from '@mui/material/Avatar';

const About = () => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    return (
        <Box height='auto'>
            <Grid container  spacing={4} rowGap={4}  flexDirection={{ xs: 'column',sm:'row', md: 'row',lg:'row' }} justifyContent={{ xs: 'center', md: 'flex-end' }}
      alignItems={{ xs: 'center', md: 'flex-end' }}>
               
                    <Grid xs={4} md={6}  textAlign={'center'} justifyContent='center'>
                        <h1 style={{ paddingBottom: 15 }} className="heading">
                            Hi There!{" "}
                            <span className="wave" role="img" aria-labelledby="wave">
                                👋🏻
                            </span>
                        </h1>

                        <h1 className="heading-name">
                            I'M
                            <strong className="main-name" style={{ color: colors.blueAccent[400] }}> KUPPANI ABHISHEK</strong>
                        </h1>

                        <Typography variant='h4' color={colors.blueAccent[400]} fontFamily='Source Sans Pro", sans-serif'>
                            <Type></Type>
                        </Typography>


                    </Grid>
                    <Grid xs={4} md={6}>
                        <img
                            src={Laptopimage}
                            alt="home pic"
                            className="img-fluid"
                            style={{ maxHeight: "320px",marginLeft:"25%" }}
                            
                        />
                    </Grid>
                
               
                    <Grid xs={6} md={6} textAlign={'center'} >
                        <Intro></Intro>
                    </Grid>
                    <Grid xs={6} md={6}  >
                        <Tilt style={{display:'flex', justifyContent:'center', alignItems:'center'}}>
                            <img src={Myimage} className="img-fluid" alt="avatar" style={{width:'50%',borderRadius:"50%"}} />
                        </Tilt>
                    </Grid>

               
                <Grid item xs={12} md={12} display='flex' flexDirection='column' justifyContent='center' alignContent='center' gap={4} height={300}>
                    <Box display='flex' justifyContent='center'>
                        <Typography variant='h1' fontStyle='bold'>Find Me On</Typography>
                    </Box>
                    <Box display='flex' justifyContent='center'>
                        <Box display='flex' gap={4} justifyContent='space-between'>
                        <Avatar sx={{bgcolor:colors.heading[100]}}>
                            <a
                                href="https://www.linkedin.com/in/abhishek-reddy-b74852221/"
                                target="_blank"
                                rel="noreferrer"
                                className="icon-colour  home-social-icons"
                            >
                                <FaLinkedinIn />
                            </a>
                            </Avatar>
                            <Avatar sx={{bgcolor:colors.heading[100]}}>
                            <a
                                href="https://github.com/abhishek-reddy-1999"
                                target="_blank"
                                rel="noreferrer"
                                className="icon-colour  home-social-icons"
                            >
                                <FaGithub />
                            </a>
                            </Avatar>
                            <Avatar sx={{bgcolor:colors.heading[100]}}>
                            <a
                                href="https://www.instagram.com/kuppani_abhishek_reddy"
                                target="_blank"
                                rel="noreferrer"
                                className="icon-colour home-social-icons"
                            >
                                <RiInstagramLine />
                            </a>
                            </Avatar>
                            

                        </Box>

                    </Box>
                </Grid>
                
            </Grid>
        </Box>
    )
}

export default About